export default __webpack_public_path__ + "static/tagore-79b1e1d3f399849c3cf165a8fba83f73.svg";